import { gql } from "@apollo/client";

export const CREATE_GROUP = gql`
  mutation CreateGroupMutation($input: CreateGroupInput!) {
    createGroup(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_GROUP = gql`
  mutation UpdateGroupMutation($id: Int!, $input: UpdateGroupInput!) {
    updateGroup(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_GROUP = gql`
  mutation RemoveGroupMutation($id: Int!) {
    removeGroup(id: $id) {
      ok
      error
    }
  }
`;

export const GROUP = gql`
  query GroupQuery($id: Int!) {
    group(id: $id) {
      ok
      error
      result {
        id
        name
        siren
        notes
      }
    }
  }
`;

export const GROUPS = gql`
  query GroupsQuery($where: GroupsFiltersInput!) {
    groups(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        name
        siren
        notes
      }
    }
  }
`;
